import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default <template>
  {{#if @forcComponent.changeset.fever}}
    <@form.NumberInput
      @propertyName='feverLevel'
      @labelName={{t 'mici-form.feverLevel.long' htmlSafe=true}}
    />
  {{/if}}
</template> satisfies TOC<Signature>;
